import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-project-setup',
  templateUrl: './project-setup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./project-setup.component.scss']
})
export class ProjectSetupComponent {
  @Input() projectId = 0;

  constructor() { }
}
